import Link from 'next/link';
import i18n from '@/settings/i18n';

// homepage holds the glossary copy for these chips; shared.json is merged under it.
const t = i18n.init('homepage');

// Names are translation keys, translated at render once the locale is set.
export const POPULAR_SEARCHES = [
  { name: 'iPhones', handle: 'apple-iphone' },
  { name: 'Samsung Phones', handle: 'samsung-phones' },
  { name: 'MacBooks', handle: 'apple-macbooks' },
  { name: 'Tablets', handle: 'tablets' },
  { name: 'Smartwatches', handle: 'smartwatches' },
  { name: 'Deals', handle: 'hot-deals' },
];

const STYLES = {
  desktop: {
    header: 'text-sm font-bold leading-normal text-gray-700',
    list: 'mt-3 flex flex-wrap gap-3',
  },
  mobile: {
    header: 'text-sm font-bold leading-normal text-gray-700',
    list: 'mt-3 flex flex-wrap gap-2',
  },
} as const;

export default function PopularSearches(props: {
  variant: 'desktop' | 'mobile';
  onSelect?: () => void;
}) {
  const styles = STYLES[props.variant];

  return (
    <section>
      <p className={styles.header}>{t`Trending Searches`}</p>
      <ul className={styles.list}>
        {POPULAR_SEARCHES.map((collection) => (
          <li key={collection.handle}>
            <Link
              href={`/collections/${collection.handle}`}
              onClick={props.onSelect}
              className="inline-flex cursor-pointer items-center rounded-full bg-gray-100 px-4 py-2 text-[13px] font-medium leading-normal text-gray-700 hover:bg-gray-200"
            >
              {t(collection.name)}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
